module.exports = __webpack_public_path__ + "img/h1.8ddf24b1.png";